import React from 'react'
import { Switch } from 'react-router-dom'
import AclRoute from 'src/components/Router/AclRoute'
import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      <AclRoute
        path='/changepolicy/vehicle'
        component={Loadable(() => import('./Vehicle'))}
        isPrivate
      />
      <AclRoute
        path='/changepolicy/other'
        component={Loadable(() => import('./Other'))}
        isPrivate
      />
      {/* <AclRoute path="/changepolicy/list" component={Loadable(() => import('./Policies'))} isPrivate /> */}
      <AclRoute
        path='/changepolicy'
        component={Loadable(() => import('./ChangePolicy.container'))}
      />
    </Switch>
  )
}

export default routes
